/* eslint-disable no-shadow */
import { createSelector } from 'reselect';
import { commercialSuppliersFilter as commercialSuppliersFilterSelector } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';

function filter(state, ownProps) {
  const { filter } = ownProps;

  return filter;
}

export function groupsSelectorFactory() {
  const groups = createSelector([filter], (filter) => filter.get('groups'));

  const isGroupsFetching = createSelector([filter], (filter) => filter.get('isGroupsFetching'));

  return {
    groups,
    isGroupsFetching,
  };
}

export function commercialSuppliersFilterFactory() {
  const commercialSuppliersFilterGroups = createSelector([commercialSuppliersFilterSelector], (filter) => {
    if (!filter) {
      return null;
    }
    return filter.get('groups');
  });

  const isCommercialSuppliersFilterGroupsFetching = createSelector([commercialSuppliersFilterSelector], (filter) => {
    if (!filter) {
      return false;
    }
    return filter.get('isGroupsFetching');
  });

  return {
    commercialSuppliersFilterGroups,
    isCommercialSuppliersFilterGroupsFetching,
  };
}
